// @ts-nocheck
import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/store/reducers';

import PageLayout from '@components/PageLayout';
import MyStoresQuickSearch from '@components/my-profile/my-stores/MyStoresQuickSearch';
import MyStoresFavouritesStoresList from '@components/my-profile/my-stores/MyStoresFavouritesStoresList';

import LoaderTable from '@loaders/LoaderTable';

import { getFavouritesStores } from '@services/myProfileServices';

import { getSortedArray } from '@utils/pages-utils/MyProfileUtils';

import { getLabelFallback } from '@utils/utils';

const MyStores = (): JSX.Element => {
    const myStoresPageTitle = getLabelFallback('MY_STORES_PAGE_TITLE');
    const myStoresBackLabel = getLabelFallback('MY_STORES_BACK_CTA_LABEL');

    const dispatch = useDispatch();

    const isMobile = useSelector((state: RootState) => state.common.isMobile);
    const config = useSelector((state: RootState) => state.common.config);
    const favouritesStores = useSelector((state: RootState) => state.myProfile.favouritesStores);
    const myProfileRequestsStatus = useSelector((state: RootState) => state.myProfile);

    useEffect(() => {
        dispatch(getFavouritesStores(config.mockRequest, config.storeId));
    }, []);

    return (
        <PageLayout
            data_element_id="AccountSummary_Profile"
            hideMenu
            labelMenu={myStoresPageTitle}
            backLabel={myStoresBackLabel}
        >
            <div className="my-stores">
                {!isMobile && (
                    <div
                        role="region"
                        aria-label="My stores page title"
                        className="primary-title mb-24"
                    >
                        {myStoresPageTitle}
                    </div>
                )}

                {myProfileRequestsStatus.getFavouritesStoresRequestStatus === 'SUCCESS' &&
                    favouritesStores.length > 0 && (
                        <>
                            <MyStoresFavouritesStoresList
                                favouritesStores={getSortedArray(favouritesStores)}
                            />
                            <hr />
                        </>
                    )}

                <MyStoresQuickSearch />

                {(myProfileRequestsStatus.getFavouritesStoresRequestStatus === 'LOADING' ||
                    myProfileRequestsStatus.removeFavouriteStoreRequestStatus === 'LOADING' ||
                    myProfileRequestsStatus.setDefaultStoreRequestStatus === 'LOADING') && (
                    <LoaderTable />
                )}
            </div>
        </PageLayout>
    );
};

export default MyStores;
